module.exports = __webpack_public_path__ + "img/2091111677834062.3ce03c3a.jpg";